<template>
  <div class="card" v-if="displayWeeks.length === numberDisplayWeek">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">{{ $t('detail.popUpChangeDateLocation.title')}}</h1>
        </div>
      </div>
    </div>
    <br/>
    <br/>
    <div class="card-content mgr-40px mgl-40px is-paddingless">
      <div class="columns is-multiline">
        <div class="buttons column is-12 is-paddingless">
          <error-msg-component :messages="messages"
                              :error="isError"
                              :title="'dateDevis.error.title'"
                              :withEmplyFields="true"
                              @close="isError = $event"/>
          <div class="is-pulled-right mgb-10px">
            <jumpWeekDatePicker
              v-model="dateDebut"
              :nb-jour-a-sauter="numberDisplayWeek * 7"
              @input="updateDate"
            />
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div v-for="(week, index) in displayWeeks" :key="index"
             class="column is-2 is-paddingless">
          <div class="borderWeekReseau">
            <p class="mgl-10px has-text-weight-bold">
              {{ getSemaine(week.anneeSemaine) }}
            </p>
            <p class="mgl-10px has-text-icon-more is-size-7 mgr-50px">
              {{ transformDate(week.anneeSemaine) }}</p>
          </div>
          <div class="borderWeekReseau has-background-background">
            <a @click="weekSelect = week.anneeSemaine">
              <disponibilite-reseau :week="week" :weekSelect="weekSelect"
                                    :devisCommande="devisCommande"></disponibilite-reseau>
            </a>
          </div>
        </div>
      </div>
      <br/>
      <div class="columns is-multiline">
        <div class="column is-12 is-paddingless">
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close">
              {{ $t('detail.popUpChangeDateLocation.cancel') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="changeLigneReseau()">
              {{ $t('detail.popUpChangeDateLocation.terminer') }}
            </a>
          </div>
        </div>
      </div>
      <br/>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import messageErreur from '@/services/general/messageErreur';
import { getAllPlanning } from '@/api/dispo/index';
import formatDate from '@/services/general/formatDate';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import getDateAnneeSemaine from '@/services/devisCommandes/getDateAnneeSemaine';
import { getAffectionOfProductTempo, updateAffectationProduitReseauTempo } from '@/services/affectation/updateAffectationProduitTempoFromDevis';
import initialisationOptionBlocage from '@/services/devisCommandes/optionBlocage/initialisationOptionBlocage';
import affectationReseauTempo from '@/services/affectation/affectationReseauTempo';
import { AUCUN } from '@/configuration/optionBlocage/optionBlocage';
import * as gestionTarifUnitaire from '@/services/devisCommandes/ligneCommande/gestionTarifUnitaire';
import getDatesDepartReseauTempo from '@/services/devisCommandes/getDatesDepartReseauTempo';
import jumpWeekDatePicker from '@/components/disponibilite/jumpWeekDatePicker';
import disponibiliteReseau from './DisponibiliteReseau';

export default {
  props: {
    ligneRegroupement: Object,
    produitId: String,
    devisCommande: Object,
  },
  components: {
    disponibiliteReseau,
    errorMsgComponent,
    jumpWeekDatePicker,
  },
  data() {
    return {
      numberDisplayWeek: 6,
      infoWeeks: [],
      displayWeeks: [],
      isError: false,
      messages: [],
      actualYear: 0,
      dateDebut: new Date(),
      weekSelect: this.ligneRegroupement.ligneReseau.anneeSemaine,
    };
  },
  methods: {
    getSemaine(anneeSemaine) {
      return this.$i18n.t('detail.popUpChangeDateLocation.week', { semaine: anneeSemaine.toString().substring(4, 6) });
    },
    async changeLigneReseau() {
      const loadingComponent = this.$buefy.loading.open();
      this.messages = [];
      const week = this.infoWeeks.find((el) => {
        return el.anneeSemaine === this.weekSelect;
      });

      if (!week) {
        this.messages.push({
          message: 'editionCommande.errors.pasDeDate',
        });
        this.isError = true;
        loadingComponent.close();
        return;
      }

      this.ligneRegroupement.ligneReseau.anneeSemaine = week.anneeSemaine;
      this.ligneRegroupement.ligneReseau.qteFacesPrevues = week.stock;

      this.ligneRegroupement.ligneReseau.qteFacesSouhaitees = !this.ligneRegroupement.produit
        .controleDisponibilite ? week.stock : (week.stock - week.vendu);

      this.ligneRegroupement.ligneReseau.jourDepart = week.jourDepart;
      this.ligneRegroupement.etatSouhaite = AUCUN;
      this.ligneRegroupement.ligneReseau.lignesCmdSelProduits.forEach(ligneCmd => {
        delete ligneCmd.id;
        ligneCmd.anneeSemaine = week.anneeSemaine;
      });
      const dates = getDatesDepartReseauTempo(week.anneeSemaine, week.jourDepart);
      this.ligneRegroupement.dateDebut = dates.dateDebut;
      this.ligneRegroupement.dateFin = dates.dateFin;
      initialisationOptionBlocage(this.ligneRegroupement);
      const affectation = await getAffectionOfProductTempo([this.ligneRegroupement]);
      await updateAffectationProduitReseauTempo(this.ligneRegroupement,
        affectation[this.ligneRegroupement.produitId]);
      gestionTarifUnitaire.toggleTarifUnitaire(this.ligneRegroupement);

      this.$emit('updatePeriodeLocation');
      loadingComponent.close();
      this.$parent.close();
    },
    transformDate(anneeSemaine) {
      return formatDate(getDateAnneeSemaine(anneeSemaine));
    },
    formatDatedebutSemaine(date) {
      return (moment(date).startOf('isoWeek'));
    },
    async firstDate(dateDebut) {
      const dateFin = (moment(dateDebut).add(this.numberDisplayWeek - 1, 'weeks')).toDate();
      this.infoWeeks = (await getAllPlanning(
        [this.ligneRegroupement.produitId], dateDebut, dateFin,
      )).data.result[this.ligneRegroupement.produitId];
      await affectationReseauTempo(
        [{ id: this.infoWeeks[0].produitId, dispo: this.infoWeeks }],
      );
      this.infoWeeks.forEach((week, index) => {
        this.$set(this.displayWeeks, index, week);
      });
    },
    async updateDate(date) {
      const loadingComponent = this.$buefy.loading.open();
      const formattedDateDebut = new Date(date);
      const sens = formattedDateDebut < this.displayWeeks[0].date ? -1 : 1;
      const dateFin = (moment(formattedDateDebut).add(this.numberDisplayWeek - 1 * sens, 'weeks')).toDate();
      this.infoWeeks = (await getAllPlanning(
        [this.ligneRegroupement.produitId], formattedDateDebut, dateFin,
      )).data.result[this.ligneRegroupement.produitId];
      await affectationReseauTempo(
        [{ id: this.infoWeeks[0].produitId, dispo: this.infoWeeks }],
      );
      this.infoWeeks.forEach((week, index) => {
        this.$set(this.displayWeeks, index, week);
      });
      loadingComponent.close();
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      let dateNow = this.devisCommande.datePremierAffichage || new Date();
      if (this.ligneRegroupement.ligneReseau.anneeSemaine) {
        dateNow = getDateAnneeSemaine(this.ligneRegroupement.ligneReseau.anneeSemaine);
      }
      await this.firstDate(dateNow);
      this.dateDebut = new Date(this.formatDatedebutSemaine(this.displayWeeks[0].date));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
